export const ZAC_VERSION = {
    "version": "4.0.0"
};
